<script>
  import { style, present, blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link } from "svelte-routing";

  export let block;
</script>

<!-- -------- START HEADER 2 w/ waves and typed text ------- -->
<section>
  <div class="page-header min-vh-100" style="background-image: url({image(block, 'background', [1500, null])});">
    <span class="mask bg-gradient-primary" style="opacity: 0.5;"></span>
    <div class="container">
      <div class="row">
        <div class="col-lg-8 text-start">
          <div class="sub-h-white">{@html richtext(block, 'headline')}</div>
          <div class="sub-h-white text-start pe-5 mt-4">{@html richtext(block, 'subheadline')}</div>
          <br />
        </div>
      </div>
    </div>
  </div>
  <div class="position-absolute w-100 z-index-1 bottom-0">
    <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 24 150 40" preserveAspectRatio="none" shape-rendering="auto">
      <defs>
        <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
      </defs>
      <g class="moving-waves">
        <use xlink:href="#gentle-wave" x="48" y="-1" fill="rgba(251,251,251,0.40" />
        <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(251,251,251,0.35)" />
        <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(251,251,251,0.25)" />
        <use xlink:href="#gentle-wave" x="48" y="8" fill="rgba(251,251,251,0.20)" />
        <use xlink:href="#gentle-wave" x="48" y="13" fill="rgba(251,251,251,0.15)" />
        <use xlink:href="#gentle-wave" x="48" y="16" fill="rgba(251,251,251,0.95" />
      </g>
    </svg>
  </div>
</section>
<!-- -------- END HEADER 2 w/ waves and typed text ------- -->
